<template>
  <div class=" width100">
    <div class="mrB15" />
    <div class="comm_scr_wrap">
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_SEARCH_PRD')"
            :vertical="false"
            :required="true"
          />
        </div>
        <div class="col-xs-11">
          <sui-range-date-picker
            ref="dp"
            v-model="rangeDate"
            class="width20"
            :value="rangeDate"
          />
          <div class="comm_line_div" />
          <div class="info">
            *{{ $t("MSG_TXT_SEARCH_UNDER_7") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_USR')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-5">
          <sui-grid
            ref="gridUser"
            class="width100"
            :hideheader="false"
            :showCountControl="true"
            :showDisplayCountControl="false"
            :initial-pagesize="3"
            :pagesizeoptions="[3]"
            :autoheight="false"
            :columns="gridColumns0"
            :dataset="'dsUser'"
            :rowMovable="false"
            :multiselect="true"
            :pageable="false"
          >
            <div class="comp_spacing" />
            <div class="btn_wrapL">
              <sui-button
                type="button"
                class="comm_btn_gridTop"
                @click="onClickBtnUserPop"
              >
                {{ $t("MSG_BTN_ADD") }}
              </sui-button>
              <sui-button
                type="button"
                class="comm_btn_gridTop"
                @click="onClickBtnUserDelete"
              >
                {{ $t("MSG_BTN_DEL") }}
              </sui-button>
            </div>
          </sui-grid>
        </div>
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_PAGE')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-5">
          <sui-grid
            ref="gridPage"
            class="width100"
            :showCountControl="true"
            :showDisplayCountControl="false"
            :columns="gridColumns1"
            :dataset="'dsPage'"
            :multiselect="true"
            :initial-pagesize="3"
            :pagesizeoptions="[3]"
          >
            <div class="comp_spacing" />
            <div class="btn_wrapL">
              <sui-button
                type="button"
                class="comm_btn_gridTop"
                @click="onClickBtnPagePop"
              >
                {{ $t("MSG_BTN_ADD") }}
              </sui-button>
              <sui-button
                type="button"
                class="comm_btn_gridTop"
                @click="onClickBtnPageDelete"
              >
                {{ $t("MSG_BTN_DEL") }}
              </sui-button>
            </div>
          </sui-grid>
        </div>
      </div>
      <div class="btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_Reset"
          @click="onClickBtnReset"
        >
          {{ $t("MSG_BTN_RESET") }}
        </sui-button>
        <sui-button
          type="button"
          class="comm_btn_Scr"
          @click="onClickBtnSearch"
        >
          {{ $t("MSG_BTN_SEARCH") }}
        </sui-button>
      </div>
    </div>
    <div class="mrB30" />
    <sui-grid
      ref="grid"
      :showCountControl="true"
      :showDisplayCountControl="false"
      :columns="gridColumns2"
      :dataset="'dsPageStats'"
      :multiselect="false"
      :initialPagesize="5"
    >
      <div class="btn_wrapR">
        <sui-button
          v-permission:download="pageId"
          type="button"
          class="comm_btn_gridTop comm_ico_excel"
          @click="onDownloadExcel"
        >
          {{ $t("MSG_BTN_EXCEL_DOWN") }}
        </sui-button>
      </div>
    </sui-grid>
    <div class="btn_moreView">
      <p
        :class="pageing.totalCount === 0 || pageing.count === pageing.totalCount ? 'disabled' : ''"
        @click="onAddList"
      >
        {{ $t("MSG_TXT_SHOW_MORE") }} {{ showMoreCount }}
      </p>
    </div>
  </div>
</template>
<script>

import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMU_00009_T01', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      required: true,
      default: 'PGE_CMU_00009',
    },
  },
  data() {
    return {
      isPageing: false,
      pageing: {
        pagePerCount: 1000,
        currentPage: 1,
        totalCount: 0,
        count: 0,
      },

      /*  eslint max-len: ["error", { "code": 200 }] */
      msgResultUnder: `*${this.$t('MSG_TXT_SRCH_RSLT')} ${utils.strFormat(this.$t('MSG_TXT_DISPLAY_RSULT_UNDER'), 1000)}`,

      rangeDate: {
        from: utils.now('YYYY-MM-DD'),
        to: utils.now('YYYY-MM-DD'),
      },

      showMoreSearchBox: {},

      localdata0: [],
      localdata1: [],
      localdata2: [],

      gridColumns0: [{
        text: this.$t('MSG_TXT_USR_ID'),
        datafield: 'knoxId',
      }, {
        text: this.$t('MSG_TXT_USR_NM'),
        datafield: 'userName',
      }, {
        text: this.$t('MSG_TXT_DEPT_NM'),
        datafield: 'departmentName',
      }],

      gridColumns1: [{
        text: this.$t('MSG_TXT_PAGE_ID'),
        datafield: 'pageId',
        width: 150,
      }, {
        text: this.$t('MSG_TXT_PAGE_NM'),
        datafield: 'pageName',
      }, {
        text: this.$t('MSG_TXT_MDLE'),
        datafield: 'moduleCode',
        width: 80,
      }, {
        text: this.$t('MSG_TXT_SMDLE'),
        datafield: 'subModuleCode',
        width: 80,
      }],

      gridColumns2: [{
        text: this.$t('MSG_TXT_USR_ID'),
        datafield: 'userId',
        width: 200,
      }, {
        text: this.$t('MSG_TXT_KNOX_ID'),
        datafield: 'knoxId',
        width: 200,
      }, {
        text: this.$t('MSG_TXT_USR_NM'),
        datafield: 'userName',
      }, {
        text: this.$t('MSG_TXT_DEPT_NM'),
        datafield: 'departmentName',
      }, {
        text: this.$t('MSG_TXT_MDLE'),
        datafield: 'moduleCodeName',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_SMDLE'),
        datafield: 'subModuleCodeName',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_PAGE_ID'),
        datafield: 'pageId',
        width: 150,
      }, {
        text: this.$t('MSG_TXT_PAGE_NM'),
        datafield: 'pageName',
      }, {
        text: this.$t('MSG_TXT_ITCN_DTM'),
        datafield: 'firstRegistrationDTM',
        createwidget: (r, c, v, h) => utils.getGridCellFactory().createCellDateLabel(r, c, v, h, this.dsPageStats, this.$refs.grid),
        initwidget: (r, c, v, h) => utils.getGridCellFactory().refreshCell(r, c, v, h),
        width: 150,
      }],
    };
  },
  computed: {
    // 계산된 속성, date pickproperty로 사용가능
    showMoreCount() {
      return `(${this.pageing.count}/${this.pageing.totalCount})`;
    },
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  datasets: [{
    id: 'dsUser',
    type: 'local',
    data: 'localdata0',
    datafields: [{
      name: 'userId',
      type: 'string',
      map: 'userId',
    }, {
      name: 'knoxId',
      type: 'string',
      map: 'knoxId',
    }, {
      name: 'userName',
      type: 'string',
      map: 'userName',
    }, {
      name: 'departmentName',
      type: 'string',
      map: 'departmentName',
    }],
  }, {
    id: 'dsPage',
    type: 'local',
    data: 'localdata1',
    datafields: [{
      name: 'pageId',
      type: 'string',
      map: 'pageId',
    }, {
      name: 'pageName',
      type: 'string',
      map: 'pageName',
    }, {
      name: 'moduleCode',
      type: 'string',
      map: 'moduleCode',
    }, {
      name: 'subModuleCode',
      type: 'string',
      map: 'subModuleCode',
    }],
  }, {
    id: 'dsPageStats',
    type: 'local',
    data: 'localdata2',
    datafields: [{
      name: 'knoxId',
      type: 'string',
      map: 'knoxId',
    }, {
      name: 'userId',
      type: 'string',
      map: 'userId',
    }, {
      name: 'userName',
      type: 'string',
      map: 'userName',
    }, {
      name: 'departmentName',
      type: 'string',
      map: 'departmentName',
    }, {
      name: 'pageId',
      type: 'string',
      map: 'pageId',
    }, {
      name: 'pageName',
      type: 'string',
      map: 'pageName',
    }, {
      name: 'moduleCodeName',
      type: 'string',
      map: 'moduleCodeName',
    }, {
      name: 'subModuleCodeName',
      type: 'string',
      map: 'subModuleCodeName',
    }, {
      name: 'statisticCreationDate',
      type: 'string',
      map: 'statisticCreationDate',
    }, {
      name: 'pageInterconnectionNumber',
      type: 'string',
      map: 'pageInterconnectionNumber',
    }, {
      name: 'firstRegistrationDTM',
      type: 'string',
      map: 'firstRegistrationDTM',
    }],
  }],
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /** ***************************************************************************
    이벤트 영역
    ***************************************************************************** */
    onClickBtnUserPop() {
      utils.openLayerPopup('PGE_CMY_00001', this.onUserPopupClose, {
        pageInitialData: {
          userPopupMode: true,
        },
        size: 'lg',
      });
    },
    onUserPopupClose(objUserList) {
      utils.forEach(objUserList, item => {
        const objUser = [{
          userId: item.userId,
          knoxId: item.knoxId,
          userName: item.userName,
          departmentName: item.departmentName,
        }];
        this.dsUser.addRows(objUser);
      });
    },
    onClickBtnUserDelete() {
      this.dsUser.deleteRows(this.dsUser.getSelectedIndexes());
    },
    onClickBtnPagePop() {
      utils.openLayerPopup('PGE_CMU_00004', this.onPagePopupClose, {
        pageInitialData: {
          multiSelect: true,
        },
        size: 'lg',
      });
    },
    onPagePopupClose(objPageList) {
      utils.forEach(objPageList, item => {
        const objPage = [{
          pageId: item.pageId,
          pageName: item.pageName,
          moduleCode: item.moduleCode,
          subModuleCode: item.subModuleCode,
        }];
        this.dsPage.addRows(objPage);
      });
    },
    onClickBtnPageDelete() {
      this.dsPage.deleteRows(this.dsPage.getSelectedIndexes());
    },
    onClickBtnSearch() {
      // date picker validation
      if (this.onClickValidate()) return false;
      // 일자
      const sStartDate = this.rangeDate.from !== null && this.rangeDate.from !== '' ? utils.dateformatToServer(this.rangeDate.from) : '';
      const sEndDate = this.rangeDate.to !== null && this.rangeDate.to !== '' ? utils.dateformatToServer(this.rangeDate.to) : '';

      if (utils.isEmpty(sStartDate) || utils.isEmpty(sEndDate)) {
        utils.messageBox('warning', this.$t('MSG_TXT_SEARCH_UNDER_7'));
        return false;
      }

      // 7일 이내로 검색
      if ((utils.isEmpty(sStartDate) === false && utils.isEmpty(sEndDate))
        || (utils.isEmpty(sEndDate) === false && utils.isEmpty(sStartDate))
        || utils.getDayOffset(this.rangeDate.to, this.rangeDate.from) > 6) {
        utils.messageBox('warning', this.$t('MSG_TXT_SEARCH_UNDER_7'));
        return false;
      }

      this.pageing.currentPage = 1;
      this.pageing.totalCount = 0;
      this.pageing.count = 0;

      this.dsPageStats.setRawData([]);

      this.setShowMoreSearchBox(sStartDate, sEndDate);
      this.searchPageStats();

      return true;
    },
    onClickBtnReset() {
      this.resetSearchBox();
    },
    onDownloadExcel() {
      const sToday = utils.now('YYYYMMDDHHmmss');
      const sExcelName = `pageLog_user_${sToday}.xlsx`;

      utils.downloadGridToExcel(this.pageid, this.gridColumns2, this.dsPageStats, sExcelName);
    },
    onAddList() {
      // 더보기
      if (this.isPageing) {
        this.pageing.currentPage += 1;
        this.searchPageStats();
      }
    },
    /** ***************************************************************************
    함수 영역
    ***************************************************************************** */
    setShowMoreSearchBox(sStartDate, sEndDate) {
      // userIdList
      const userIdList = [];
      utils.forEach(this.dsUser.data, item => {
        userIdList.push(item.userId);
      });

      // pageIdList
      const pageIdList = [];
      utils.forEach(this.dsPage.data, item => {
        pageIdList.push(item.pageId);
      });

      // 일자
      const queryParams = {
        userIdList: userIdList.join(','),
        pageIdList: pageIdList.join(','),
        startDate: sStartDate.substr(0, 14),
        endDate: `${sEndDate.substr(0, 8)}235959`,
      };

      this.showMoreSearchBox = queryParams;
      return false;
    },
    resetSearchBox() {
      this.dsUser.setRawData([]);
      this.dsPage.setRawData([]);

      this.rangeDate = { from: utils.now('YYYY-MM-DD'), to: utils.now('YYYY-MM-DD') };
    },
    searchPageStats() {
      // 더보기 클릭시 기존 searchBox 값 유지를 위해 위치 변경 ()
      // // date picker validation
      // if (this.onClickValidate()) return false;
      // // 일자
      // const sStartDate = this.rangeDate.from !== null && this.rangeDate.from !== '' ? utils.dateformatToServer(this.rangeDate.from) : '';
      // const sEndDate = this.rangeDate.to !== null && this.rangeDate.to !== '' ? utils.dateformatToServer(this.rangeDate.to) : '';

      // if (utils.isEmpty(sStartDate) || utils.isEmpty(sEndDate)) {
      //   utils.messageBox('warning', this.$t('MSG_TXT_SEARCH_UNDER_7'));
      //   return false;
      // }

      // // 7일 이내로 검색
      // if ((utils.isEmpty(sStartDate) === false && utils.isEmpty(sEndDate))
      //   || (utils.isEmpty(sEndDate) === false && utils.isEmpty(sStartDate))
      //   || utils.getDayOffset(this.rangeDate.to, this.rangeDate.from) > 6) {
      //   utils.messageBox('warning', this.$t('MSG_TXT_SEARCH_UNDER_7'));
      //   return false;
      // }


      // // userIdList
      // const userIdList = [];
      // utils.forEach(this.dsUser.data, item => {
      //   userIdList.push(item.userId);
      // });

      // // pageIdList
      // const pageIdList = [];
      // utils.forEach(this.dsPage.data, item => {
      //   pageIdList.push(item.pageId);
      // });

      // // 일자
      // const queryParams = {
      //   userIdList: userIdList.join(','),
      //   pageIdList: pageIdList.join(','),
      //   startDate: sStartDate.substr(0, 14),
      //   endDate: sEndDate.substr(0, 14),
      // };

      const queryParams = utils.cloneDeep(this.showMoreSearchBox);

      // pageing
      utils.assign(queryParams, { pagePerCount: this.pageing.pagePerCount });
      utils.assign(queryParams, { currentPage: this.pageing.currentPage });

      http.request(this.pageId, 'DTS_CMU_00054', {
        query: queryParams,
      }).then(res => {
        if (utils.isUndefined(res.data) === false && res.data.length === this.pageing.pagePerCount) {
          this.isPageing = true;
        } else {
          this.isPageing = false;
        }

        const union = utils.mergeArray(this.dsPageStats.data, res.data);
        this.dsPageStats.setRawData(union);

        this.pageing.count = this.dsPageStats.data.length;
        if (res.data.length > 0) {
          this.pageing.totalCount = res.data[0].totalCount;
        }
      }).catch(error => {
        console.log(error);
      });
      return true;
    },
    /* 달력의 오류를 확인할 수 있는 validate 함수 */
    onClickValidate() {
      // date picker validation
      // if (this.onClickValidate()) return false;
      if (!this.$refs.dp.isValid()) {
        utils.messageBox('warning', this.$t('MSG_ALT_CHK_DT'), null, null);
        return true;
      }
      return false;
    },
  },
};
</script>
<style scoped>
</style>
